import React from 'react';
import { ValidationNotification } from '@pb/shared/ui/molecules/validation-notification';
import { TFormElementProperties } from './form-element.types';
import {
    StyledLabel,
    StyledHelperText,
    StyledValidationNotificationContainer,
    StyledFormElementContainer,
    StyledInputContainer,
} from './form-element.styled';

export function FormElement({
    id,
    labelText,
    helperText,
    renderInput,
    validationState = 'error',
    validationMessage,
    ...properties
}: TFormElementProperties) {
    let inputElement;
    const hasError = Boolean(validationState === 'error' && validationMessage);
    if (typeof renderInput === 'function') {
        inputElement = renderInput({ id, hasError });
    }

    return (
        <StyledFormElementContainer {...properties}>
            {labelText && <StyledLabel id={id}>{labelText}</StyledLabel>}
            {helperText && <StyledHelperText>{helperText}</StyledHelperText>}
            {inputElement && (
                <StyledInputContainer>{inputElement}</StyledInputContainer>
            )}
            {validationMessage && (
                <StyledValidationNotificationContainer>
                    <ValidationNotification
                        state={validationState}
                        marginBottom="none"
                    >
                        {validationMessage}
                    </ValidationNotification>
                </StyledValidationNotificationContainer>
            )}
        </StyledFormElementContainer>
    );
}
